import { Component, OnInit, ViewChild } from "@angular/core";
import { HttpServiceAccount } from "../services/Authorization/http/http.service_Account";
import { TopBar } from "src/classes/Authorization/BusinessRole";
import { Menu } from "primeng/menu";
import { NGXLogger } from "ngx-logger";
import { ExtendedMenuItem } from "src/classes/Common/PrimeNGMenuItem";

type MenuElement = {
    label: string;
    icon: string;
    link: string;
    badge: number;
}

@Component({
    selector: "app-topbar",
    templateUrl: "./topbar.component.html",
    styleUrls: ["./topbar.component.css"],
    providers: [HttpServiceAccount],
})
export class TopbarComponent implements OnInit {
    // Made a particular interface for MenuElement and SubMenuElement
    menu: MenuElement[] = [];
    submenu: ExtendedMenuItem[] = [{
        menu_Id: 0,
        label: "יציאה",
        routerLink: ["/login"],
        command: () => {
            // this.httpServiceAccount.removeBusinessByConstr({ constr: sessionStorage.getItem("businessUserName") })
        }
    }];

    // Count of skeleton items can be adjusted by changing the number of elements in the array
    skeletonMenu: number[] = new Array(5).fill(0);
    showSkeleton: boolean = true;

    userName: string;

    @ViewChild("menu", { static: false }) subMenu: Menu;

    constructor(
        private httpServiceAccount: HttpServiceAccount,
        private logger: NGXLogger
    ) { }

    ngOnInit() {
        this.httpServiceAccount.getTopBar()
            .subscribe((data: TopBar[]) => {
                data.sort((a, b) => a.tb_order_id - b.tb_order_id)
                    .forEach((element: TopBar) => {
                        this.menu.push({ label: element.tb_name, icon: element.icon_name, link: element.link, badge: 0 });
                    });

                this.showSkeleton = false;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        this.userName = sessionStorage.getItem("userFullName");
    }

    openSubMenu(event: MouseEvent): void {
        this.subMenu.toggle(event);
    }
}